export const formatToMMDDYYYY = (date: Date) => {
    const month = formatMonth(date.getMonth());
    const day = formatDay(date.getDate());
    const year = date.getFullYear().toString();

    return month + '/' + day + '/' + year;
};

const formatMonth = (month: number): string => {
    month += 1;
    if (month > 9) {
        return month.toString();
    }
    return '0' + month.toString();
};

const formatDay = (day: number): string => {
    if (day > 9) {
        return day.toString();
    }
    return '0' + day.toString();
};

/**
 * This is intented for strings formatted like YYYY-MM-DD to MM/DD/YYYY
 */
export const formatDateString = (dateString: string) => {
    const [year, month, day] = dateString.split('-');

    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    return formatToMMDDYYYY(date);
};
